import { Component } from '@angular/core';

@Component({
  selector: 'pdf-find-current-page-only',
  templateUrl: './pdf-find-current-page-only.component.html',
  styleUrls: ['./pdf-find-current-page-only.component.css'],
})
export class PdfFindCurrentPageOnlyComponent {}
